import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { tipoff } from "@/lib/format";
import { Panel } from "@/components/AppShell";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export function GameTeamPicker({ day, setDay, gameId, setGameId, teamId, setTeamId }) {
  const [games, setGames] = useState([]);
  const prevDay = useRef(day);
  useEffect(() => {
    if (prevDay.current !== day) { setGameId(""); setTeamId(""); }  // keep a deep-linked game/team on first load
    prevDay.current = day;
    api.get("/games", { params: { day } }).then((r) => setGames(r.data)).catch(() => setGames([]));
  }, [day, setGameId, setTeamId]);
  const game = games.find((g) => g.id === gameId);
  const sides = game ? [["away", game.away_team_id, game.away_code], ["home", game.home_team_id, game.home_code]] : [];
  return (
    <Panel className="p-4 flex flex-wrap items-end gap-4" data-testid="rotation-picker">
      <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">Date
        <Input data-testid="rotation-date-input" type="date" value={day} onChange={(e) => e.target.value && setDay(e.target.value)} className="mt-1 w-44 bg-slate-900/70" />
      </label>
      <label className="text-xs uppercase tracking-widest text-slate-400 font-bold">Game
        <Select value={gameId} onValueChange={(v) => { setGameId(v); setTeamId(""); }}>
          <SelectTrigger data-testid="rotation-game-select" className="mt-1 w-72 bg-slate-900/70"><SelectValue placeholder={games.length ? "Select game" : "No games"} /></SelectTrigger>
          <SelectContent>
            {games.map((g) => (
              <SelectItem key={g.id} value={g.id} data-testid={`rotation-game-${g.id}`}>
                {g.away_code} @ {g.home_code} · {g.status === "post" ? `Final ${g.away_pts}-${g.home_pts}` : tipoff(g.date_utc)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </label>
      {sides.length > 0 && (
        <div className="flex gap-2" role="group">
          {sides.map(([side, id, code]) => (
            <button key={side} type="button" data-testid={`rotation-team-${side}`} onClick={() => setTeamId(id)}
              className={`h-10 px-4 inline-flex items-center gap-2 rounded-md border font-display text-lg font-bold uppercase tracking-wide transition-colors ${
                teamId === id ? "border-blue-400 bg-blue-600/20 text-blue-200" : "border-slate-700 text-slate-400 hover:text-slate-100"}`}>
              {code && <img src={`https://a.espncdn.com/i/teamlogos/nba/500/${code.toLowerCase()}.png`} alt="" className="ra-team-logo" data-testid={`rotation-team-logo-${side}`} onError={(e) => { e.currentTarget.style.display = "none"; }} />}
              {code} <span className="text-xs text-slate-500">{side}</span>
            </button>
          ))}
        </div>
      )}
    </Panel>
  );
}
